import { ChannelPageTableValueCell, ChannelPageTableValueCellType} from "./ChannelPageTableValueCell.js";
import { ChannelPageTableKeyCell } from "./ChannelPageTableKeyCell.js"

export function getChannelPageTableRows(channelRow){
    const rows = [
        {id: "ATSC3 Deployment Status", fieldKey: "ATSC3 Deployment Status:", fieldValue: channelRow.atsc3_deployed},
        {id: "BA Blackout Log File Name", fieldKey: "BA Blackout Log File Name:", fieldValue: channelRow.ba_blackout_log_file_name},
        {id: "DMA Code", fieldKey: "DMA Code:", fieldValue: channelRow.dma_code},
        {id: "Host or Non-Host For ATSC3", fieldKey: "Host or Non-Host For ATSC3:", fieldValue: channelRow.host_or_non_host_for_atsc3},
        {id: "Log Types For BA Blackout", fieldKey: "Log Types For BA Blackout:", fieldValue: channelRow.ba_blackout_log_types},

        {id: "Market", fieldKey: "Market:", fieldValue: channelRow.market},
        {id: "Sinclair Station Status", fieldKey: "Sinclair Station Status:", fieldValue: channelRow.sinclair_station_status},
        {id: "Call Sign", fieldKey: "Call Sign:", fieldValue: channelRow.call_sign},
        {id: "Affiliation", fieldKey: "Affiliation:", fieldValue: channelRow.affiliation},
        {id: "Station Logo", fieldKey: "Station Logo:", fieldValue: channelRow.station_affiliate_name},

        {id: "Website", fieldKey: "Website:", fieldValue: channelRow.website_vod_assets},
        {id: "Wide Orbit Log Recieved Format", fieldKey: "Wide Orbit Log Recieved Format:", fieldValue: channelRow.wide_orbit_log_recieved_format},
        {id: "Wide Orbit File Type", fieldKey: "Wide Orbit File Type:", fieldValue: channelRow.wide_orbit_file_type},
        {id: "Receiving Daily WO Logs?", fieldKey: "Receiving Daily WO Logs?:", fieldValue: channelRow.receiving_daily_WO_logs},
        {id: "ATSC3 Deployment Version", fieldKey: "ATSC3 Deployment Version:", fieldValue: channelRow.atsc3_deployment_version},

        {id: "ATSC1 Deployment Status", fieldKey: "ATSC1 Deployment Status:", fieldValue: channelRow.atsc1_vp1_deployed},
        {id: "ATSC1 Deployment Version", fieldKey: "ATSC1 Deployment Version:", fieldValue: channelRow.atsc1_deployment_version},
        {id: "ATSC3 GSID", fieldKey: "ATSC3 GSID:", fieldValue: channelRow.atsc3_gsid},
        {id: "Digicaster IP Addresses", fieldKey: "Digicaster IP Addresses:", fieldValue: channelRow.digicaster_ip_addresses},
        {id: "Google Analytics Deployment Verified", fieldKey: "Google Analytics Deployment Verified:", fieldValue: channelRow.google_analytics_deployment_verified},

        {id: "Time Zone", fieldKey: "Time Zone:", fieldValue: channelRow.time_zone},
        {id: "Notes", fieldKey: "Notes:", fieldValue: channelRow.notes},
        {id: "BSID (3.0) or TSID (1.0) Verance Required Info", fieldKey: "BSID (3.0) or TSID (1.0) Verance Required Info:", fieldValue: channelRow.bsid3_or_tsid1_verance_required_info},
        {id: "Major Minor Virtual Channel Number", fieldKey: "Major Minor Virtual Channel Number:", fieldValue: channelRow.major_minor_virtual_channel_number},
        {id: "Verance Service ID", fieldKey: "Verance Service ID:", fieldValue: channelRow.verance_service_id},

        {id: "Signal Signed", fieldKey: "Signal Signed:", fieldValue: channelRow.signal_signed},
        {id: "Site Content", fieldKey: "Site Content:", fieldValue: channelRow.site_content},
        {id: "Headlines Newsletter", fieldKey: "Headlines Newsletter:", fieldValue: channelRow.headlines_newsletter},
        {id: "News App", fieldKey: "News App:", fieldValue: channelRow.news_app},
        {id: "Weather Newsletter", fieldKey: "Weather Newsletter:", fieldValue: channelRow.weather_newsletter},

        {id: "Weather App", fieldKey: "Weather App:", fieldValue: channelRow.weather_app},
        {id: "Contact", fieldValue: channelRow.station_contacts},
    ]
    return rows;
}


export function getChannelPageTableColumnHeaders(sizeStatus, callSign, affiliate){
    const columnHeaders = [
        {
            field: 'fieldKey', 
            headerName: 'fieldKey',
            flex: 4,
            colSpan: (_value, row) => {
                if (row.id === 'Contact') return 2
                else return 1
            },
            renderCell: (params) => <ChannelPageTableKeyCell sizeStatus={sizeStatus} callSign={callSign} affiliate={affiliate} {...params} />
        },
        {
            resizable: true,
            field: 'fieldValue', 
            ...ChannelPageTableValueCellType,
            headerName: 'fieldValue',
            renderCell: (params) => <ChannelPageTableValueCell sizeStatus={sizeStatus} callSign={callSign} affiliate={affiliate} {...params} />,
            align: 'left',
            flex: 5,
            colSpan: 1,
        },
    ]
    return columnHeaders;
}
